import { IRequestModel } from '../../interfaces/models/requests.interfaces'
import { ResidentUserType } from './units'

export const requestsForSociety = (
  requests?: IRequestModel[],
  residentUserType?: ResidentUserType
): IRequestModel[] => {
  if (residentUserType === ResidentUserType.MEMBER) {
    return (
      requests?.filter(
        (_request) => _request.role === 'member' || _request.role === 'resident'
      ) || []
    )
  }
  if (residentUserType === ResidentUserType.NON_MEMBER) {
    return (
      requests?.filter(
        (_request) => _request.role !== 'member' && _request.role !== 'resident'
      ) || []
    )
  }

  return requests || []
}
